import { createRouter, createWebHashHistory } from 'vue-router'
import { getToken } from '@/utils/auth'
import loginRoutes from './login'
import newsRoutes from './news'
import koiRoutes from './koi'
import marketRoutes from './market'
import chatRoutes from './chat'
import walletRoutes from './wallet'
import partnerRoutes from './partner'
import merchantRoutes from './merchant'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home/HomeView.vue'),
    meta: {
      title: '首页',
      keepAlive: false,
      requireAuth: true
    }
  },
  {
    path: '/splash',
    name: 'splash',
    component: () => import('../views/login/SplashView.vue'),
    meta: {
      title: '欢迎',
      keepAlive: false,
      requireAuth: false
    }
  },
  // 登录相关路由
  ...loginRoutes,
  // 消息相关路由
  ...newsRoutes,
  // 客服聊天相关路由
  ...chatRoutes,
  // KOI 相关路由
  ...koiRoutes,
  // 行情相关路由
  ...marketRoutes,
  // 捐赠钱包相关路由
  ...walletRoutes,
  // 联盟合伙人相关路由
  ...partnerRoutes,
  // 联盟主理人相关路由
  ...merchantRoutes,
  // 权益卡路由
  {
    path: '/card',
    name: 'card',
    component: () => import('../views/card/CardView.vue'),
    meta: {
      title: '锦鲤品牌权益卡',
      keepAlive: false,
      requireAuth: true
    }
  },
  // 资产页面路由
  {
    path: '/assets',
    name: 'assets',
    component: () => import('../views/assets/AssetsView.vue'),
    meta: {
      title: '资产',
      keepAlive: false,
      requireAuth: true
    }
  },
  // USDT 提现页面路由
  {
    path: '/usdt',
    name: 'usdt',
    component: () => import('../views/usdt/UsdtView.vue'),
    meta: {
      title: 'USDT',
      keepAlive: false,
      requireAuth: true
    }
  },
  // 设置提现密码页面路由
  {
    path: '/set-withdraw-password',
    name: 'set-withdraw-password',
    component: () => import('../views/usdt/SetWithdrawPasswordView.vue'),
    meta: {
      title: '设置提现密码',
      keepAlive: false,
      requireAuth: true
    }
  },
  // 提现页面路由
  {
    path: '/withdraw',
    name: 'withdraw',
    component: () => import('../views/usdt/WithdrawView.vue'),
    meta: {
      title: '提现',
      keepAlive: false,
      requireAuth: true
    }
  },
  // 兑换页面路由
  {
    path: '/exchange',
    name: 'exchange',
    component: () => import('../views/koi/ExchangeView.vue'),
    meta: {
      title: '兑换',
      keepAlive: false,
      requireAuth: true
    }
  },
  // 我的页面路由
  {
    path: '/my',
    name: 'my',
    component: () => import('../views/my/MyView.vue'),
    meta: {
      title: '我的',
      keepAlive: false,
      requireAuth: true
    }
  },
  // 邀请好友页面路由
  {
    path: '/invite',
    name: 'invite',
    component: () => import('../views/my/InviteView.vue'),
    meta: {
      title: '邀请好友',
      keepAlive: false,
      requireAuth: true
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFoundView.vue'),
    meta: {
      title: '页面不存在',
      keepAlive: false
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title || 'Web3 App'

  // 检查是否需要登录
  if (to.meta.requireAuth) {
    const token = getToken()
    if (!token) {
      next({
        path: '/splash',
        query: { redirect: to.fullPath }
      })
      return
    }
  }

  next()
})

router.afterEach(() => {
  // 页面切换后的处理
})

export default router
